<div
  class="min-h-screen pb-page-bottom"
  [ngStyle]="getBackgroundStyles()"
>
  <app-block-list [blockIdList]="body()"></app-block-list>
  <router-outlet></router-outlet>
</div>
